export const IS_PRODUCTION = process.env.NODE_ENV === 'production'
// eslint-disable-next-line unicorn/prefer-global-this -- using `typeof window` to safely detect non-browser environments; `globalThis` is always defined
export const IS_SERVER = typeof window === 'undefined'

export const GITHUB_USERNAME = 'zeyadhanydev'

export const SITE_NAME = 'Zeyad Hany'
export const SITE_KEYWORDS = ['Zeyad Hany', 'Next.js', 'React', 'TypeScript', 'Node.js']

export const SITE_GITHUB_URL = 'https://github.com/zeyadhanydev'
export const SITE_FACEBOOK_URL = 'https://www.facebook.com/zeyadhany'
export const SITE_INSTAGRAM_URL = 'https://www.instagram.com/zeyadhany'
export const SITE_X_URL = 'https://x.com/zeyadhany_1'
export const SITE_YOUTUBE_URL = 'https://www.youtube.com/@zeyadhany'

export const COMMENT_TYPES = ['comment', 'reply'] as const
export const USER_ROLES = ['user', 'admin'] as const
